import { render } from "./AssessmentInfo.vue?vue&type=template&id=6a0f3402&scoped=true"
import script from "./AssessmentInfo.vue?vue&type=script&lang=js"
export * from "./AssessmentInfo.vue?vue&type=script&lang=js"

import "./AssessmentInfo.vue?vue&type=style&index=0&id=6a0f3402&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a0f3402"]])

export default __exports__